import appLocaleData from 'react-intl/locale-data/de';
import saMessages from '../locales/de.json';
import { getCustomerConfig } from '../../utils/SettingsRetriever.js';

const extendedTranslations = getCustomerConfig();
// const locales = extendedTranslations.config.hasOwnProperty("locales") ? extendedTranslations.config.locales : null;
let locales = [];
if(extendedTranslations.config && extendedTranslations.config.locales){
  locales = extendedTranslations.config.locales;
}

let translations = saMessages;
if (locales && locales['de']) {
  translations = {
    ...saMessages,
    ...locales['de']
  }
}

const saLang = {
  messages: {
    ...translations
  },
  locale: 'de',
  data: appLocaleData
};
export default saLang;
